// Most Arkii API errors come back as { error: { code, message, fields? } },
// but at least one endpoint (transcript line edits) returns DRF's bare
// ValidationError shape instead — { transcription_lines: ["..."] }, no
// "error" wrapper. Handle both rather than silently falling through to the
// generic message on the second shape.
export function extractErrorMessage(err) {
  const data = err?.response?.data;
  const apiError = data?.error;

  if (apiError) {
    if (apiError.fields) {
      const fieldMessages = Object.entries(apiError.fields).map(
        ([field, issues]) => `${field}: ${issues.map((issue) => issue.message).join(", ")}`
      );
      if (fieldMessages.length) {
        return fieldMessages.join(" ");
      }
    }
    return apiError.message || "Something went wrong.";
  }

  if (data && typeof data === "object") {
    const messages = Object.values(data).flat().filter((value) => typeof value === "string");
    if (messages.length) return messages.join(" ");
  }

  return err?.message || "Something went wrong.";
}
